var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#F4F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    rx: 4,
    transform: "matrix(-1 0 0 1 17 4)",
    stroke: "#BCD5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H12V4H11C8.79086 4 7 5.79086 7 8V11Z",
    stroke: "#BCD5F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17 5.79086 15.2091 4 13 4H12V11H17V8Z",
    stroke: "#F4F9FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17 5.79086 15.2091 4 13 4H12V11H17V8Z",
    stroke: "#2264C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseRight);
export default __webpack_public_path__ + "static/media/MouseRight.572fff6be2e73c0477a00d55f4aed925.svg";
export { ForwardRef as ReactComponent };